<pr-query-filter-display
  icon="database"
  label="Data source"
  [values]="dataSource()?.name ?? 'Unknown'"
/>
